import React from 'react';
import { FullViewProps } from '../types';
import DeviationMediaService from '../../../utils/DeviationMediaService';
import { MediaSrcFile } from '../../../utils/DeviationMediaService/types';

export const PdfFullView: React.FC<FullViewProps> = ({
  deviation,
  width,
  height,
}) => {
  const pdfFiles = DeviationMediaService.getMediaByType(deviation, 'pdf');
  if (!pdfFiles || pdfFiles.length === 0) {
    return null;
  }

  const pdfFile: MediaSrcFile = pdfFiles.pop()!;

  return (
    <>
      <head>
        <link rel="preload" href={pdfFile.src} as="object" />
      </head>
      <object
        aria-label={deviation.title}
        data={pdfFile.src}
        style={{ width, height }}
        type="application/pdf"
      />
    </>
  );
};

export default PdfFullView;
